require('../assets/javascripts/application.js')
require('../assets/stylesheets/application.scss')
require.context('../assets/images', true)
